import React from "react";
import ControlMachineForm from "./ControlMachineForm";
import { Paper, withStyles, Grid } from "@material-ui/core";
import { BackButton } from '../../sc-utilities';
import { connect } from "react-redux";
import * as Yup from "yup";
import * as actions from "./store/controlMachineActions";
import History from "../../../History";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    }
});

const ControlMachineCreate = props => {
    const { classes, activeCustomerID, translations, permissions, onCreateControlMachine } = props;

    const handleSubmit = async data => {
        const params = {
            ActiveCustomerID: activeCustomerID,
            Name: data.Name ?? null,
            MajorVersion: data.MajorVersion ?? null,
            MinorVersion: data.MinorVersion ?? null,
            BuildNumber: data.BuildNumber ?? null,

        }
        let result = await onCreateControlMachine(params);
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        HardwareID: '',
        Name: '',
        RemoteID: '',
        RemotePassword: '',
        LicenseName: '',
        ExpiresAt: '',
        LicenseStatus: '',
        MajorVersion: 0,
        MinorVersion: 0,
        BuildNumber: 0
    };

    let formSettings = {
        ValidationForm: {
            Name: Yup.string().required("Required"),
            MajorVersion: Yup.number().required("Required"),
            MinorVersion: Yup.number().required("Required"),
            BuildNumber: Yup.number().required("Required")
        },
        FormTitle: translations["control_machine_create"] || "Create offline Command Station",
        ButtonSubmit: {
            Title: translations["save"] || "SAVE"
        }
    };

    return (
        <Paper className={classes.root}>
            <Grid container spacing={10}>
                <Grid item xs={12}>
                    {BackButton(translations)}
                    <ControlMachineForm
                        classes={classes}
                        formSettings={formSettings}
                        initialValues={initialValues}
                        handleSubmit={handleSubmit}
                        translations={translations}
                        permissions={permissions}
                        CustomerIDPreviousState={''}
                        forOffline={true}
                    />
                </Grid>
            </Grid>
        </Paper>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCreateControlMachine: controlMachine => dispatch(actions.createControlMachine(controlMachine))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(ControlMachineCreate));